import React, { useEffect } from 'react'
import "./second-onboard-screen.css"
import uniqid from "uniqid";
import axios from "axios";

const SecondOnboardScreen = ({show, firstOption, secondOption, onClickOut, onSkip, step = 1}) => {
    // Generate session ID on component mount
    useEffect(() => {
        const initializeSessionId = async () => {
            if (!localStorage.getItem("sessionId")) {
                const sessionId = await generateSessionId();
                localStorage.setItem("sessionId", sessionId);
                console.log(`Generated new sessionId: ${sessionId}`);
            }
        };
        initializeSessionId();
    }, []);

    // Function to generate a session ID via server API
    const generateSessionId = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/generate-session-id`);
            if (response.data && response.data.sessionId) {
                console.log(`✅ [CLIENT-DEBUG] Server generated session ID: ${response.data.sessionId}`);
                return response.data.sessionId;
            } else {
                throw new Error('Invalid response from session generation API');
            }
        } catch (error) {
            console.error('❌ [CLIENT-DEBUG] Failed to generate session ID from server:', error.message);
            const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
            let fallbackId = 'b';
            for (let i = 0; i < 5; i++) {
                fallbackId += chars[Math.floor(Math.random() * chars.length)];
            }
            console.log(`🔄 [CLIENT-DEBUG] Generated fallback session ID: ${fallbackId}`);
            return fallbackId;
        }
    };

    // Function to handle option selection and generate UID
    const handleOptionSelect = (optionFunction) => {
        if (!localStorage.getItem("uniqueUserId")) {
            const uid = uniqid();
            localStorage.setItem("uniqueUserId", uid);
            console.log(`Generated new uniqueUserId: ${uid}`);
        }
        optionFunction();
    };

    return (
        <div onClick={onClickOut} className={`obs-overlay ${show ? "show" : ""}`}>
            <div onClick={e => e.stopPropagation()} className="obs-card">
                <div className="obs-ambient"></div>
                <div className="obs-ambient obs-ambient-2"></div>

                <div className="obs-step">
                    <span className="obs-step-num">{step}</span>
                    <span className="obs-step-sep">/</span>
                    <span className="obs-step-total">2</span>
                </div>

                <div className="obs-content">
                    <h2 className="obs-heading">עבור מי התמונות?</h2>
                    <p className="obs-subtitle">הבחירה שלכם תעזור לנו להבין טוב יותר איך לארוז את האריזה</p>

                    <div className="obs-choices">
                        <div className="obs-choice" onClick={() => handleOptionSelect(firstOption)}>
                            <div className="obs-choice-icon">
                                <img src="../../assets/images/self-icon.png" alt="" />
                            </div>
                            <span className="obs-choice-text">עבורי</span>
                            <svg className="obs-choice-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className="obs-choice-divider"></div>
                        <div className="obs-choice" onClick={() => handleOptionSelect(secondOption)}>
                            <div className="obs-choice-icon">
                                <img src="../../assets/images/gift-icon.png" alt="" />
                            </div>
                            <span className="obs-choice-text">עבור קרוב (מתנה)</span>
                            <svg className="obs-choice-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>

                    <div className="obs-tip">
                        <p>כיף להיות בבית מאורגן עם תמונות של הסובבים</p>
                        <img src="../assets/images/info-circle.svg" alt="" />
                    </div>
                </div>

                <div className="obs-footer">
                    <div className="obs-progress-track">
                        <div className="obs-progress-fill" style={{ width: `${step * 50}%` }}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SecondOnboardScreen;
